import * as SagasType from '../constants/constant_saga_types';
import * as ActionType from '../constants/constant_action_types';

/** Action creators for inventory transfer */

export function fetchInventoryTransferList(silent, filters) {
  return { type: SagasType.FETCH_LIST_INVENTORY_TRANSFER, silent, filters };
}

export function saveInventoryTransfer(data) {
  return { type: SagasType.SAVE_INVENTORY_TRANSFER, data };
}

export function getInventoryTransfer(id, intl) {
  return { type: SagasType.GET_INVENTORY_TRANSFER, id, intl };
}

export function initializeMassInventoryTransfer(
  from_location_id,
  from_subsidiary_id,
) {
  return {
    type: SagasType.INITIALIZE_MASS_INVENTORY_TRANSFER,
    from_location_id,
    from_subsidiary_id,
  };
}

export function getInventoryTransferLineItemLocation(
  locationId,
  itemId,
  index,
  itemUom,
) {
  return {
    type: SagasType.GET_INVENTORY_TRANSFER_LINE_ITEM_LOCATION,
    locationId,
    itemId,
    index,
    itemUom,
  };
}

export function getAllTransferLineItemLocation(locationId) {
  return {
    type: SagasType.GET_ALL_INVENTORY_TRANSFER_LINES_ITEM_LOCATION,
    locationId,
  };
}

export function getInventoryTransferPreferences(
  subsidiaryId,
  locationId,
  intl,
) {
  return {
    type: SagasType.GET_PREFERENCES_BY_FROM_LOCATION,
    subsidiaryId,
    locationId,
    intl,
  };
}

export function clearInventoryTransfer() {
  return { type: ActionType.CLEAR_INVENTORY_TRANSFER };
}

export function setTransferFormLinePagination(pagination) {
  return { type: ActionType.SET_TRANSFER_FORM_LINE_PAGINATION, pagination };
}

export function selectLinesByStatus(inventoryStatusId) {
  return { type: SagasType.SELECT_LINES_BY_STATUS, inventoryStatusId };
}

export function setLinesReceivedQuantity() {
  return { type: SagasType.SET_LINES_RECEIVED_QUANTITY };
}

/** Action creators for inventory adjustment */

export function fetchInventoryAdjustmentList(silent, filters) {
  return { type: SagasType.FETCH_LIST_INVENTORY_ADJUSTMENT, silent, filters };
}

export function getInventoryAdjustment(id) {
  return { type: SagasType.GET_INVENTORY_ADJUSTMENT, id };
}

export function saveInventoryAdjustment(data, redirectToView) {
  return { type: SagasType.SAVE_INVENTORY_ADJUSTMENT, data, redirectToView };
}

export function deleteInventoryAdjustment(id) {
  return { type: SagasType.DELETE_INVENTORY_ADJUSTMENT, id };
}

export function deleteInventoryAdjustmentFromList(id) {
  return { type: SagasType.DELETE_INVENTORY_ADJUSTMENT_FROM_LIST, id };
}

export function clearInventoryAdjustment() {
  return { type: ActionType.CLEAR_INVENTORY_ADJUSTMENT };
}

export function getAdjustmentLineItemLocation(locationId, itemId, index, itemUom) {
  return {
    type: SagasType.GET_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION,
    locationId,
    itemId,
    index,
    itemUom
  };
}

export function getAllAdjustmentLineItemLocation(locationId) {
  return {
    type: SagasType.GET_ALL_INVENTORY_ADJUSTMENT_LINE_ITEM_LOCATION,
    locationId,
  };
}

export function fetchInventoryStocktakeList(silent, filter) {
  return { type: SagasType.FETCH_LIST_INVENTORY_STOCKTAKE, silent, filter };
}

export function getInventoryStocktake(id) {
  return { type: SagasType.GET_INVENTORY_STOCKTAKE, id };
}

export function saveInventoryStocktake(data) {
  return { type: SagasType.SAVE_INVENTORY_STOCKTAKE, data };
}

export function deleteInventoryStocktake(id) {
  return { type: SagasType.DELETE_INVENTORY_STOCKTAKE, id };
}

export function deleteInventoryStocktakeFromList(id) {
  return { type: SagasType.DELETE_INVENTORY_STOCKTAKE_FROM_LIST, id };
}

export function clearInventoryStocktake() {
  return { type: ActionType.CLEAR_INVENTORY_STOCKTAKE };
}

export function getInventoryStocktakeItemLocations(locationId) {
  return { type: SagasType.GET_INVENTORY_STOCKTAKE_ITEM_LOCATIONS, locationId };
}

export function openInventoryStocktakeReferenceIdModal(state, header, index) {
  return {
    type: ActionType.OPEN_INVENTORY_STOCKTAKE_REFERENCE_ID_MODAL,
    state,
    header,
    index,
  };
}

export function setStocktakeFormLinePagination(pagination) {
  return { type: ActionType.SET_STOCKTAKE_FORM_LINE_PAGINATION, pagination };
}

export function exportStockTakeToDoc(payload) {
  return { type: SagasType.EXPORT_STOCKTAKE_TO_DOC, payload };
}
